import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DEMO_CUSTOMER, DEMO_PARTNER, UserAccount } from '../models';
import { IS_DEMO, SELECTED_CUSTOMER, SELECTED_PARTNER } from '../constants';
import { DemoDataService } from './demo-data.service';
import { AuthStore, DemoStore, SelectedCustomerStore, SelectedPartnerStore } from '../stores';

@Injectable({ providedIn: 'root' })
export class DemoService {
  private readonly authStore = inject(AuthStore);
  private readonly demoStore = inject(DemoStore);
  private readonly selectedCustomerStore = inject(SelectedCustomerStore);
  private readonly selectedPartnerStore = inject(SelectedPartnerStore);
  private readonly demoDataService = inject(DemoDataService);
  private readonly httpClient = inject(HttpClient);

  isDemo(): boolean {
    return this.demoStore.isDemoMode();
  }

  activateDemo() {
    localStorage.setItem(IS_DEMO, 'true');
    this.demoStore.setIsDemoMode(true);
    this.selectedCustomerStore.setSelectedCustomer(DEMO_CUSTOMER);
    this.selectedPartnerStore.setSelectedPartner(DEMO_PARTNER);
    this.authStore.setUser(this.demoDataService.getDemoUserAccount());
    window.location.reload();
  }

  deactivateDemo() {
    localStorage.removeItem(IS_DEMO);
    this.demoStore.setIsDemoMode(false);
    this.setSelectedCustomerAndPartner();
    this.loadCurrentUser().subscribe((user) => {
      this.authStore.setUser(user);
      window.location.reload();
    });
  }

  private setSelectedCustomerAndPartner() {
    const selectedCustomerStr = localStorage.getItem(SELECTED_CUSTOMER);
    const selectedPartnerStr = localStorage.getItem(SELECTED_PARTNER);
    this.selectedCustomerStore.setSelectedCustomer(selectedCustomerStr ? JSON.parse(selectedCustomerStr) : null);
    this.selectedPartnerStore.setSelectedPartner(selectedPartnerStr ? JSON.parse(selectedPartnerStr) : null);
  }

  private loadCurrentUser(): Observable<UserAccount> {
    return this.httpClient.get<any>('/api/me').pipe(
      map((_user) => {
        return UserAccount.mapFromApiValue(_user);
      }),
    );
  }
}
